import { css } from '@emotion/react';

import brazeInAppCustom from '~styles/brazeInAppCustom';
import { pretandard } from '~styles/fontFamily';

import { boxModel } from './boxModel';

const globalStyle = css`
  ${boxModel()},
  *,
  *::after,
  *::before {
    box-sizing: border-box;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-smoothing: antialiased;
    font-family: inherit;
  }
  html,
  body {
    margin: 0;
    padding: 0;
  }
  html {
    height: 100%;
    font-family: ${pretandard.style.fontFamily};
  }
  body {
    min-height: 100%;
    margin: 0;
    padding: 0;
  }
  #__next {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0;
    padding: 0;
    border: 0;
  }
  ol,
  ul,
  li {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  button {
    cursor: pointer;
    background: none;
    border: none;
    outline: none;
    padding: 0;
    :disabled {
      cursor: default;
    }
  }
  p,
  dt,
  dd {
    margin: 0;
    padding: 0;
  }
  a {
    all: unset;
    cursor: pointer;
  }
  h1,
  h2,
  h3,
  h4,
  h5 {
    margin: 0;
  }
  ${brazeInAppCustom};
`;

export default globalStyle;
